/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useReducer, useRef, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { Box, fade } from '@material-ui/core';
import { bgimage } from '../constants';
import PageLayout from '../shared/PageLayout';
import PopupFormOperationView from '../shared/PopupFormOperationView';
import TabsList from '../components/TabsList';
import useCompany from '../../hooks/useCompany';
import { getStoreItem, setStoreItem } from '../../store';
import {
  CustomerContext,
  customerReducer,
  initCustomerContext,
} from '../../contexts/managment';
import Customers from '../shared/Customers';

import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import AlsardalOrder from './AlsardalOrder';

export default function OrderOperations({
  isRTL,
  words,
  user,
  theme,
  menuitem,
  formgroup,
  drawerWidth,
}: any) {
  const [item, setItem] = useState(null);
  const [openItem, setOpenItem] = useState(false);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const invoiceref: any = useRef();
  const receiptref: any = useRef();
  const customerref: any = useRef();

  const { height, width } = useWindowDimensions();
  const { company } = useCompany();

  const customerStoreState = getStoreItem('customerStore', initCustomerContext);
  const [customerStore, customerDispatch] = useReducer(
    customerReducer,
    customerStoreState ? customerStoreState : initCustomerContext
  );
  useEffect(() => {
    setStoreItem('customerStore', customerStore);
  }, [customerStore]);

  const onCloseItem = () => {
    setOpenItem(false);
    setItem(null);
  };

  const handleSelect = (item: any) => {
    navigate(item?.path);
  };

  const refresh = () => {
    if (pathname?.includes('invoices')) {
      invoiceref?.current?.refresh();
    }
    if (pathname?.includes('receipts')) {
      receiptref?.current?.refresh();
    }
    if (pathname?.includes('customers')) {
      customerref?.current?.refresh();
    }
  };

  const bgcolor = '#23A46C08';

  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      theme={theme}
      refresh={refresh}
      bgcolor={bgcolor}
      bgimage={bgimage}
      width={width - drawerWidth}
    >
      <Box
        style={{
          height: height - 50,
          overflow: 'auto',
        }}
      >
        <Box
          display="flex"
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: 50,
            marginLeft: 50,
            marginTop: 5,
            height: 50,
          }}
        ></Box>
        <Paper
          elevation={5}
          style={{
            borderRadius: 25,
            margin: 25,
            marginTop: 5,
            width: width - drawerWidth - 50,
            height: height - 135,
          }}
        >
          <TabsList
            handleSelect={handleSelect}
            isRTL={isRTL}
            list={formgroup}
            theme={theme}
            width={width - drawerWidth - 50}
            color={fade(theme?.palette?.secondary?.main, 0.2)}
            pathname={pathname}
          ></TabsList>
          <Paper
            style={{
              display: 'flex',
              height: height - 185,
              overflow: 'auto',
              borderBottomLeftRadius: 25,
              borderBottomRightRadius: 25,
              backgroundColor: '#3454D133',
            }}
          >
            <Routes>
              <Route
                index
                element={<Navigate to={formgroup?.[0]?.path} replace />}
              />
              <Route
                path={'reservation'}
                element={
                  <AlsardalOrder
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                  ></AlsardalOrder>
                }
              />

              <Route
                path={'customers'}
                element={
                  <CustomerContext.Provider
                    value={{ state: customerStore, dispatch: customerDispatch }}
                  >
                    <Customers
                      ref={customerref}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                    ></Customers>
                  </CustomerContext.Provider>
                }
              />
            </Routes>
          </Paper>
        </Paper>
        <PopupFormOperationView
          open={openItem}
          onClose={onCloseItem}
          row={item}
          theme={theme}
          isRTL={isRTL}
          words={words}
          user={user}
        ></PopupFormOperationView>
      </Box>
    </PageLayout>
  );
}
